export const stats = [
  { value: '+48', label: 'Units Ready to Teach' },
  { value: '4,200+', label: 'Satisfied Teachers' },
  { value: '2,500+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend' },
]

export const differenceStats = [
  { value: '+48', label: 'Ready-to-Teach Units', note: 'Every core concept covered' },
  { value: '6', label: 'Complete Digital Volumes', note: 'Grades 7 to 12' },
  { value: '100%', label: 'Instantly Downloadable', note: 'Start teaching in 3 minutes' },
]

export const beforeItems = [
  'Hours hunting for worksheets that actually match the curriculum',
  'Searching endlessly for safe, accurate experiments',
  'No ready-made assessments or grading rubrics',
  'Struggling to keep students engaged with dry, heavy text',
  'Unmotivated students who say "science is too hard"',
]

export const afterItems = [
  "5-minute review and you're set for the day",
  'Visual and engaging concept maps for every unit',
  'Safe, low-cost labs using everyday materials',
  'Quizzes, final exams, and answer keys ready to print',
  'Students mastering concepts with visual confidence',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arriving to class without knowing exactly how to explain a complex formula',
  },
  {
    emoji: '⏱️',
    text: 'Spending your entire Sunday planning what should take minutes',
  },
  {
    emoji: '🤷',
    text: 'Struggling to find lab experiments that are actually high-quality, safe, and affordable',
  },
  {
    emoji: '📋',
    text: 'No clear assessments or rubrics aligned with the school year',
  },
  {
    emoji: '😴',
    text: 'Students falling behind because text-heavy materials are boring',
  },
  { emoji: '🌙', text: 'Still not ready for Monday by Sunday night' },
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Complete Curriculum Volumes (Grades 7–12)',
    text: 'One deep, visual book for every secondary year',
  },
  {
    emoji: '🏛️',
    title: '48 Classroom-Tested Units',
    text: 'From basic forces to advanced organic chemistry',
  },
  {
    emoji: '✏️',
    title: 'Ready-to-Say Teacher Scripts',
    text: 'Confidence-boosting explanations for every topic',
  },
  {
    emoji: '📐',
    title: 'Visual Theory & Worksheets',
    text: 'High-quality graphics students actually enjoy reading',
  },
  {
    emoji: '📊',
    title: 'Assessments & Final Exams',
    text: '6 cumulative tests to measure real progress',
  },
  {
    emoji: '🔑',
    title: 'Full Answer Keys',
    text: 'Grading is finally instant and stress-free',
  },
]

export const instantItems = [
  'The 6 complete digital volumes (The Foundations through The Advanced Pathway)',
  'Visual concept maps, student activities, and low-cost labs in every book',
  'Teacher scripts that tell you exactly what to say to make it click',
  'Full solutions manual for every worksheet and exam',
]

export const bonuses = [
  {
    title: 'The 5-Minute Class Ignition Vault™',
    text: '150 lesson starters',
    was: '$29',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/eb32cbc7-be03-4677-b8b2-bb6ac8c9e512.jpg',
  },
  {
    title: 'The Zero-Budget Lab Kit™',
    text: '24 extra safe practicals',
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/cd8353e6-05c8-40c3-886c-a7a795b52cad.jpg',
  },
  {
    title: 'The Formula Confidence Pack™',
    text: 'Visual calculation guides',
    was: '$29',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4340cf6a-681c-4ab6-9765-3b5296b87507.jpg',
  },
  {
    title: 'The Science Teacher Confidence Scripts™',
    text: 'Ready-to-say explanations',
    was: '$29',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4886daa2-3970-43ad-961a-05b195f1cfc2.jpg',
  },
  {
    title: 'The Fast-Grade Assessment Toolkit™',
    text: 'Rapid feedback tools',
    was: '$33',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/abcb4478-efc0-432c-ac2c-164304bc23c7.jpg',
  },
]

export const offerRows = [
  { label: '6 Curriculum Volumes (Grades 7–12)', value: '$97' },
  { label: '5 Exclusive Bonuses', value: '$148' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. The labs use materials I already have in my cupboard. Best $27 I’ve spent.',
    name: 'Sarah M.',
    location: 'UK 🇬🇧',
  },
  {
    quote:
      'As a non-specialist teaching Physics, the Confidence Scripts gave me the authority I was missing.',
    name: 'David L.',
    location: 'USA 🇺🇸',
  },
  {
    quote:
      'The visual concept maps finally made the Mole and Organic Chemistry click for my Year 11s.',
    name: 'Marco R.',
    location: 'Canada 🇨🇦',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Instant download links via email.',
  },
  {
    q: 'Does this work for non-specialists?',
    a: 'Yes, it’s designed to make you sound like an expert.',
  },
  {
    q: 'What grade levels does this cover?',
    a: 'Secondary school (Grades 7–12 / Years 7–12).',
  },
  {
    q: 'Are the bonuses included?',
    a: 'Yes, if you order before the timer hits zero.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. One single payment for life.',
  },
]
